import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageMadrid = props => {
  return <CityLandingPage cityKey="Madrid" cityConfig={cityContent.madrid} {...props} />;
};

export default LandingPageMadrid;
